var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{key:_vm.$route.fullPath,attrs:{"is-loading":_vm.isLoading,"setups":_vm.setups}})
}
var staticRenderFns = []

export { render, staticRenderFns }